/* eslint-disable no-restricted-globals */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/jsx-props-no-spreading */
import queryString from "query-string";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { Box } from "@mui/material";
import EmptyFileIcon from "../../../../assets/svg/EmptyFile";
import ReloadIcon from "../../../../assets/svg/ReloadIcon";
import SearchIconWithPeople from "../../../../assets/svg/SearchIconWithPeople";
import AppliedFilter from "../../../../components/common/AppliedFilter/AppliedFilter";
import Loader from "../../../../components/common/Loader/Loader";
// import Pagination from "../../../../components/common/new/Pagination/Pagination";
import {
  AppliedFilterLabelMap,
  DATES,
  EVENT_NAME,
  Constants,
  AlertStatus,
} from "../../../../contants";
import useParamsQuery from "../../../../hooks/useParamsQuery";
import { selectOSKeysByUserRole } from "../../../../redux/selectors/user";
import Reports from "../../../../services/api/reports";
import { formDataToObject, isEmptyObj } from "../../../../utils/helper";
import styles from "../FriendSearch.styles";
import ReportTable from "./FriendSummaryReportTable/FriendSummaryReportTable";
// import OrganizationSearch from "../../Components/OrganizationSearch";
import OrganizationSearch from "../../SubscriptionReports/OrganizationSearchReports";
import Popover from "../../../member/MemberSearch/Popover/Popover";
import {
  getFilters,
  getFormattedQuery,
  getRouteForFriendSummary,
  handleDependencyFilter,
  // performOperation,
} from "../utils";
import { ToastAlertContext } from "../../../../config/providers/ToastAlert";
import DateRangePicker from "../../../../components/common/DateRangePicker/DateRangePicker";
import Button from "../../../../components/common/Button";
// import ExportButton from "../FriendToMemberTrend/Components/ExportButton";
import ExportButton from "./Components/ExportButton";

const LOADER_DELAY = 1000;
const PAGE = "page";
const FILTER_KEYS = {
  PERSONAL_FILTER: "personal-filter",
  ORGANISATION_STRUCTURE_FILTER: "orgainsation-structure-filter",
};
const SEARCH_FILTERS = [
  {
    key: FILTER_KEYS.ORGANISATION_STRUCTURE_FILTER,
    component: OrganizationSearch,
    popOverprops: { heading: "Organization Structure", minWidth: 413 },
  },
];
const filterOrder = [
  "areaId",
  "clusterId",
  "zoneId",
  "regionId",
  "chapterId",
  "districtId",
  "blockId",
];
const initialFormValue = {
  dateFrom: "",
  dateTo: "",
};
function FriendSummaryReports() {
  const [searchData, setSearchData] = useState([]);
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const formRef = useRef(null);
  const navigate = useNavigate();
  const metaData = useSelector((state) => state.meta);
  const disabledOSKeys = useSelector(selectOSKeysByUserRole);
  const { getQueryObject, getQueryParams, urlSearchParams } = useParamsQuery();
  const [currentPage, setCurrentPage] = useState(0);
  // const [totalPages, setTotalPages] = useState(0);
  // const [totalElements, setTotalElements] = useState(0);
  const [pageSize, setPageSize] = useState(Constants.DEFAULT_PAGE_SIZE);
  const [initialAdvanceFormValue, setInitialAdvanceFormValue] =
    useState(initialFormValue);
  const toast = useContext(ToastAlertContext);
  const clearFormRef = () => {
    Object.keys(AppliedFilterLabelMap).forEach((key) => {
      if (formRef.current[key]) {
        formRef.current[key].value = "";
        formRef.current[key]?.blur();
      }
    });
  };
  const resetFormState = () => {
    setSearchData([]);
    setAppliedFilters([]);
    clearFormRef();
  };
  const initializeFormState = (queryObject) => {
    if (!isEmptyObj(queryObject)) {
      clearFormRef();
      Object.keys(queryObject).forEach((key) => {
        if (formRef.current[key]) {
          formRef.current[key].value = queryObject[key];
        }
      });
    }
  };
  const updateSearchParam = (query) => {
    if (query?.length) {
      navigate(`${getRouteForFriendSummary()}?${query}`);
    } else {
      navigate(`${getRouteForFriendSummary()}`);
    }
  };
  const removeKeyFromQuery = (queryObject, filterKey) => {
    let updatedQuery = {
      ...queryObject,
      // pageNumber: 0,
      // pageSize: Constants.DEFAULT_PAGE_SIZE,
    };
    if (DATES.includes(filterKey)) {
      delete updatedQuery[filterKey];
      delete updatedQuery[`${filterKey.split("From")[0]}To`];
    } else {
      delete updatedQuery[filterKey];
    }
    if (Object.keys(updatedQuery).length === 1 && PAGE in updatedQuery) {
      delete updatedQuery[PAGE];
    }
    updatedQuery = handleDependencyFilter(updatedQuery, disabledOSKeys);
    return updatedQuery;
  };
  const onRemoveFilter = (filterKey) => {
    let queryObject = getQueryObject();
    queryObject = removeKeyFromQuery(queryObject, filterKey);
    const updatedQuery = queryString.stringify(queryObject);
    updateSearchParam(updatedQuery);
  };
  const validateAndFetchData = (formattedQuery, toast, setIsLoading) => {
    if (
      !formattedQuery.hasOwnProperty("areaId") ||
      formattedQuery.areaId === ""
    ) {
      toast.show("Please enter Area", AlertStatus.ERROR);
      setIsLoading(false);
      return false;
    }
    return true;
  };
  const fetchSearchData = async (
    queryParams
    // pageNumber = 0,
    // pageSize = Constants.DEFAULT_PAGE_SIZE
  ) => {
    try {
      setIsLoading(true);
      const formattedQuery = getFormattedQuery({
        ...queryParams,
        // pageNumber,
        // pageSize,
      });
      if (validateAndFetchData(formattedQuery, toast, setIsLoading)) {
        const response = await Reports.FriendSummaryReport(formattedQuery);
        if (response.code === 200 && response.message === "") {
          setIsLoading(false);
        }
        const { data } = response;
        // Showing some delay to avoid loader flicker issue
        setSearchData(data);
        setCurrentPage(data?.number);
        // setTotalPages(data?.totalPages);
        // setTotalElements(data?.totalElements);
        setPageSize(pageSize);
        setTimeout(() => {
          setIsLoading(false);
        }, LOADER_DELAY);
      }
    } catch (error) {
      setIsLoading(false);
      toast.show(
        error.message || "Something went wrong. Please contact support.",
        AlertStatus.ERROR
      );
      Sentry.captureException(error);
    }
  };
  const onSubmit = (e) => {
    e.preventDefault();
    const rawFormData = new FormData(formRef.current);
    const formData = formDataToObject(rawFormData);
    // formData.pageNumber = 0;
    // formData.pageSize = Constants.DEFAULT_PAGE_SIZE;
    const query = queryString.stringify(formData);
    document.dispatchEvent(new Event(EVENT_NAME));
    updateSearchParam(query);
  };
  useEffect(() => {
    const queryObject = getQueryObject();
    if (!isEmptyObj(queryObject)) {
      const [query] = getQueryParams(queryObject);
      fetchSearchData(query);
      initializeFormState(query);
      Object.keys(initialFormValue).forEach((key) => {
        setInitialAdvanceFormValue((prev) => ({
          ...prev,
          [key]: query[key] ?? "",
        }));
      });
    } else {
      resetFormState();
      setInitialAdvanceFormValue(initialFormValue);
    }
  }, [urlSearchParams.toString()]);
  useEffect(() => {
    const queryObject = getQueryObject();
    if (!isEmptyObj(queryObject)) {
      const query = getQueryParams(queryObject)[0];
      setAppliedFilters(getFilters(query, metaData, disabledOSKeys));
    }
  }, [metaData, urlSearchParams.toString()]);
  // const onPaginationClick = (clickedNumber) => {
  //   const queryObject = getQueryObject();
  //   const queryParams = queryString.stringify({
  //     ...queryObject,
  //     pageNumber: clickedNumber,
  //   });
  //   updateSearchParam(queryParams);
  // };
  // const onPageSizeClick = (operator) => {
  //   const queryObject = getQueryObject();
  //   const queryParams = queryString.stringify({
  //     ...queryObject,
  //     pageNumber: 0,
  //     pageSize: queryObject.pageSize
  //       ? performOperation(
  //           queryObject.pageSize,
  //           Constants.DEFAULT_PAGE_SIZE,
  //           operator
  //         )
  //       : 2 * Constants.DEFAULT_PAGE_SIZE,
  //   });
  //   updateSearchParam(queryParams);
  // };
  const onRefresh = () => {
    const queryObject = getQueryObject();
    const [query] = getQueryParams(queryObject);
    fetchSearchData(query);
  };
  const clearAllFilter = () => {
    updateSearchParam();
  };
  const orderedFilters = filterOrder
    .map((filterKey) =>
      appliedFilters.find((filter) => filter.key === filterKey)
    )
    .filter(Boolean);
  const additionalFilters = appliedFilters.filter(
    (filter) => !filterOrder.includes(filter.key)
  );
  return (
    <div style={styles.container}>
      <div style={styles.filter}>
        <form style={styles.left} onSubmit={onSubmit} ref={formRef}>
          {/* {SEARCH_FILTERS.map(({ component: Component, popOverprops, key }) => (
            <Popover key={key} {...popOverprops}>
              <Component formRef={formRef} disabledOSKeys={disabledOSKeys} />
            </Popover>
          ))} */}
          <Box
            sx={{
              display: "flex",
              gap: "20px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {SEARCH_FILTERS.map(
              ({ component: Component, popOverprops, key }) => (
                <Popover key={key} {...popOverprops}>
                  <Component
                    formRef={formRef}
                    disabledOSKeys={disabledOSKeys}
                  />
                </Popover>
              )
            )}
            <DateRangePicker
              label="Period"
              name="date"
              startDateVal={initialAdvanceFormValue.dateFrom}
              endDateVal={initialAdvanceFormValue.dateTo}
            />
            <Button label="Search" type="submit" />
          </Box>
        </form>
        <div style={styles.right}>
          <ExportButton
            data={searchData}
            exportFunction={Reports.downloadFriendSummaryReport}
          />
          <div style={styles.reload} onClick={onRefresh}>
            <ReloadIcon />
          </div>
        </div>
      </div>
      <div style={styles.main}>
        {/* {searchData?.length ? (
          <div style={styles.totalElements}>Total Results: {totalElements}</div>
        ) : null} */}
        {appliedFilters.length ? (
          <div style={styles.filterWrapper}>
            <div style={styles.filterContainer}>
              {orderedFilters.map((filter) => (
                <AppliedFilter
                  key={filter.key}
                  filter={filter}
                  onRemove={onRemoveFilter}
                />
              ))}
              {additionalFilters.map((filter) => (
                <AppliedFilter
                  key={filter.key}
                  filter={filter}
                  onRemove={onRemoveFilter}
                />
              ))}
            </div>
            <div style={styles.clearAll} onClick={clearAllFilter}>
              Clear
            </div>
          </div>
        ) : null}
        {searchData?.length ? (
          <>
            <ReportTable
              searchData={searchData}
              currentPage={currentPage}
              pageSize={pageSize}
            />
            <div style={styles.pagination}>
              {/* <Pagination
                totalPages={totalPages}
                totalResults={totalElements}
                currentPage={currentPage}
                pageSize={pageSize}
                onChange={onPaginationClick}
                onPageSizeClick={onPageSizeClick}
              /> */}
            </div>
          </>
        ) : (
          <div style={styles.initialContent}>
            {appliedFilters.length ? (
              <>
                <EmptyFileIcon width={100} />
                <span style={styles.text}>
                  No data found with current Filters
                </span>
              </>
            ) : (
              <>
                <SearchIconWithPeople width={100} />
                <span style={styles.text}>Choose your Search Filter</span>
              </>
            )}
          </div>
        )}
      </div>
      {isLoading && <Loader />}
    </div>
  );
}
export default FriendSummaryReports;
